import type { erros as pt } from '../pt-BR/erros';
import type { Traducao } from '../Traducao';

export const erros = {
  REQUISICAO_INVALIDA: 'The data sent is invalid.',
  NAO_AUTENTICADO: 'Your session has expired. Please sign in again.',
  SEM_PERMISSAO: 'You do not have permission for this action.',
  NAO_ENCONTRADO: 'Not found.',
  MUITAS_REQUISICOES: 'Too many attempts. Wait a minute.',
  ERRO_INESPERADO: 'An unexpected error occurred. Please try again.',
  REDE: 'Connection failed. Please try again.',
  CREDENCIAIS_INVALIDAS: 'Invalid email or password.',
  USUARIO_NAO_ENCONTRADO: 'User not found.',
  USUARIO_JA_EXISTE: 'A user with this email already exists.',
  LOGIN_SENHA_DESLIGADO: 'Password login is turned off.',
  REFRESH_INVALIDO: 'Your session has expired. Please sign in again.',
  AXIIS_INDISPONIVEL:
    'The professional records are temporarily unavailable. Try again in a few minutes.',
  PERIODO_INVALIDO: 'The end date cannot be before the start date.',
  ENTREGA_PREVISTA_INVALIDA:
    'Enter both dates, and the end date must not be before the start date.',
  OUTRA_CAMPANHA_ATIVA: 'There is already an active campaign: {{nome}}. Deactivate it first.',
  CAMPANHA_NAO_ENCONTRADA: 'Campaign not found.',
  CEP_INVALIDO: 'The postal code must have 8 digits.',
  CEP_NAO_ENCONTRADO: 'Postal code not found.',
  CEP_INDISPONIVEL: 'The postal code lookup is temporarily unavailable.',
  RESPOSTA_INVALIDA: 'Some answers are invalid. Check the marked fields.',
  RESPOSTA_DESATUALIZADA:
    'Your answers were changed in another window. We are showing the latest version; check it before saving again.',
  SEM_VINCULO:
    'We could not find your professional record. Contact the team in charge of the campaign.',
  NAO_PARTICIPANTE:
    'You are not on the participant list for this campaign. Contact the team in charge of the campaign.',
  PARTICIPANTE_EXCLUIDO: 'You are no longer part of this campaign.',
  CAMPANHA_AGENDADA: 'The campaign has not started yet.',
  CAMPANHA_FECHADA: 'The campaign is not accepting answers.',
  EXPORTACAO_INCONSISTENTE:
    'Responses with an invalid address or size: {{quantidade}}. Take the list below to system support before exporting.',
  PARTICIPANTE_NAO_ENCONTRADO: 'Participant not found.',
  AZURE_NAO_CONFIGURADO: 'Microsoft login is not configured.',
  CAMPANHA_NAO_SINCRONIZAVEL: 'Only a campaign that has not ended can be synchronized.',
  CAMPANHA_TERMINADA: "This campaign's period has ended.",
  ULTIMO_ADMINISTRADOR: 'The system needs at least one active administrator.',
  SINCRONIZACAO_EM_ANDAMENTO: 'A synchronization is already in progress. Please wait.',
  CAMPANHA_SEM_RETENTATIVA: 'You can only try again on an active campaign.',
  RODADA_EM_ANDAMENTO: 'A sending is already in progress for this campaign.',
  CAMPANHA_SEM_CONVITE: 'Invitations can only be sent for an active campaign that has not ended.',
  SELECAO_DESATUALIZADA: 'The list changed since you made your selection. Review it and try again.',
  VARIAVEL_DESCONHECIDA:
    'The text has an unknown variable. Use {nome}, {campanha}, {inicio} or {fim}.',
  SELECAO_VAZIA: 'No one in the selection is in the campaign to receive the invitation.',
  INATIVO_NO_AXIIS: 'This person is inactive in the registry and cannot return to the campaign.',
  JA_PARTICIPANTE: 'This person is already a participant in the campaign.',
  NAO_ENCONTRADO_NO_AXIIS: 'This person was not found in the registry.',
  EXPORTACAO_MUITO_GRANDE:
    'The list has {{quantidade}} people; the maximum per file is 5000. Apply filters and export again.',
} as const satisfies Traducao<typeof pt>;
